import { Avatar } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player/lazy";
import { Helmet, HelmetData } from "react-helmet-async";
import Seo from "./Helmet";
const Bodycontent = ({ video, videoId }) => {
  return (
    <div className="col w-full bg-black">
      {/*<Seo Image={video.VidoeImage} videoId={videoId} />*/}
      <div className="flex flex-col pl-3 pr-3">
        <div className="mr-auto ml-auto bg-black">
          <ReactPlayer
            className="justify-center"
            controls={true}
            url={video.VideoUrl}
            light={<img src={video.VidoeImage} height="100%" width="100%" />}
            loop={true}
            height="100%"
            width="100%"
            style={{
              borderRadius: "12px",

              boxShadow: "0 4px 10px rgba(77, 73, 73, 0.55)",
            }}
          />
          <p className="text-white pt-3 text-lg">{video.Videotitle}</p>
          <div className="pt-4 flex flex-row w-1/2 items-center">
            <Avatar
              alt="Remy Sharp"
              src={video.userImage}
              sx={{
                width: 48,
                height: 48,
                border: "1px solid rgba(93, 89, 86, 0.65)",
                boxShadow: "0 4px 10px rgba(125, 120, 120, 0.8)",
              }}
            />
            <p className="text-white text-cente font-sans text-lg ml-5">
              {video.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bodycontent;
